module.exports = __webpack_public_path__ + "img/logo_app.47f90108.jpg";